import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import "./NoBreak.css";

export default class NoBreakUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("applyNoBreak", (locale) => {
      const command = editor.commands.get("applyNoBreak");
      const nobreakButtonView = new ButtonView();

      nobreakButtonView.set({
        isToggleable: true,
        label: t("\u2050"),
        withText: true,
        tooltip: "No Break",
      });

      nobreakButtonView
        .bind("isOn", "isEnabled")
        .to(command, "isNoBreakOn", "isEnabled");
      nobreakButtonView.on("execute", (e) => {
        command.execute("nobreak");
      });
      return nobreakButtonView;
    });
  }
}
